import { PreviewParams } from "../constants/ProtocolParams";
export const getEnvNameFromNetwork = (network) => {
    switch (network) {
        case 0:
            return "preview";
        case 1:
        default:
            return "mainnet";
    }
};
export const getNetworkFromEnvName = (name) => {
    switch (name) {
        case "mainnet":
            return 1;
        default:
            return 0;
    }
};
export class SSLProvider {
    constructor(address, network, api) {
        this.address = address;
        this.network = network;
        this.connectedAPI = api;
    }
    // Replace with API call.
    async getProtocolParameters() {
        switch (this.network) {
            case "Preview":
            case "Testnet":
            case "Preprod":
                return PreviewParams;
            default:
                return "";
        }
    }
    // Replace with ping API call.
    async awaitTx(txHash) {
        return new Promise((res) => {
            setTimeout(() => res, 2000);
        });
    }
    // Replace with API call.
    async getDelegation(rewardAddress) {
        return "";
    }
    // Replace with API call.
    async getUtxoByUnit(asset) {
        return {
            address: "",
            assets: [],
            outputIndex: 0,
            txHash: "",
        };
    }
    // Replace with API call.
    async getUtxosByOutRef(outRefs) {
        return {
            address: "",
            assets: [],
            outputIndex: 0,
            txHash: "",
        };
    }
    // Replace with API call.
    async getDatum(datumHash) {
        return "";
    }
    // Replace with API call.
    async getUtxos(address) {
        return this.connectedAPI.getUtxos();
    }
    // Replace with API call.
    async getUtxosWithUnit(address, unit) {
        return [];
    }
    async submitTx(tx) {
        return this.connectedAPI.submitTx(tx);
    }
}
//# sourceMappingURL=wallet.js.map